import * as Types from '@trello/graphql/generated';

import { DocumentNode } from 'graphql';
import * as Apollo from '@apollo/client';
const defaultOptions =  {"context":{"operationName":"ListHeaderCell"}}
export type ListHeaderCellQueryVariables = Types.Exact<{
  idOrg: Types.Scalars['ID'];
  idBoards: Array<Types.Scalars['ID']> | Types.Scalars['ID'];
}>;


export type ListHeaderCellQuery = (
  { __typename: 'Query' }
  & { organization?: Types.Maybe<(
    { __typename: 'Organization' }
    & { boards: Array<(
      { __typename: 'Board' }
      & Pick<Types.Board, 'id' | 'name'>
      & { lists: Array<(
        { __typename: 'List' }
        & Pick<Types.List, 'id' | 'name'>
      )> }
    )> }
  )> }
);


export const ListHeaderCellDocument: DocumentNode = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"ListHeaderCell"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"idOrg"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"idBoards"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"organization"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"idOrg"}}}],"directives":[{"kind":"Directive","name":{"kind":"Name","value":"client"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"boards"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"ids"},"value":{"kind":"Variable","name":{"kind":"Name","value":"idBoards"}}},{"kind":"Argument","name":{"kind":"Name","value":"boardLabelsLimit"},"value":{"kind":"IntValue","value":"100"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"lists"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"EnumValue","value":"open"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}}]}}]};

/**
 * __useListHeaderCellQuery__
 *
 * To run a query within a React component, call `useListHeaderCellQuery` and pass it any options that fit your needs.
 * When your component renders, `useListHeaderCellQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListHeaderCellQuery({
 *   variables: {
 *      idOrg: // value for 'idOrg'
 *      idBoards: // value for 'idBoards'
 *   },
 * });
 */
export function useListHeaderCellQuery(baseOptions: Apollo.QueryHookOptions<ListHeaderCellQuery, ListHeaderCellQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ListHeaderCellQuery, ListHeaderCellQueryVariables>(ListHeaderCellDocument, options);
      }
export function useListHeaderCellLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ListHeaderCellQuery, ListHeaderCellQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ListHeaderCellQuery, ListHeaderCellQueryVariables>(ListHeaderCellDocument, options);
        }
export type ListHeaderCellQueryHookResult = ReturnType<typeof useListHeaderCellQuery>;
export type ListHeaderCellLazyQueryHookResult = ReturnType<typeof useListHeaderCellLazyQuery>;
export type ListHeaderCellQueryResult = Apollo.QueryResult<ListHeaderCellQuery, ListHeaderCellQueryVariables>;